import { render } from "./ProfitCard.vue?vue&type=template&id=6eefc40e&scoped=true"
import script from "./ProfitCard.vue?vue&type=script&lang=js"
export * from "./ProfitCard.vue?vue&type=script&lang=js"

import "./ProfitCard.vue?vue&type=style&index=0&id=6eefc40e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core-Abudari\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6eefc40e"]])

export default __exports__